var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"demo-icon"},[_c('div',{staticClass:"demo-icon-container"},[_c('ul',_vm._l((_vm.icons),function(icon){return _c('li',{key:icon},[_c('sv-icon',{attrs:{"name":icon}}),_c('span',[_vm._v(_vm._s(icon))])],1)}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }